import { styled } from '@mui/system';
import Link from '@mui/material/Link';

const Picture = styled('div')(({ imgurl }) => ({
  backgroundImage: `url(${imgurl})`,
  backgroundSize: 'cover',
  width: '170px',
  height: '170px',
}));

const InnerYellowFrame = styled('div')({
  width: 'calc(100% - 16px)',
  height: 'calc(100% - 16px)',
  border: '1px solid #AB9178',
  padding: '12px',
  display: 'flex',
  alignItems: 'flex-end',
});

const ShadowLayer = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(180.23deg, rgba(77, 67, 67, 0) 62.73%, rgba(0, 0, 0, 0.94) 84.74%);',
});

const NoteTitle = styled('div')({
  fontFamily: 'Fjalla One',
  fontSize: '17px',
  fontWeight: 50,
  lineHeight: '20px',
  color: '#fff',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
});

const NoteCardDetail = (props) => {
  const imgurl = () => {
    const defaultImg = props.avatar;
    if (
      props.attachments == undefined ||
      props.attachments == null ||
      props.attachments.length <= 0
    ) {
      return defaultImg;
    } else {
      return props.attachments[0].url;
    }
  };
  const linkUrl = `/note/${props._id}`;

  return (
    <Link href={linkUrl} underline="none">
      <Picture imgurl={imgurl()}>
        <ShadowLayer>
          <InnerYellowFrame>
            <NoteTitle>{props.title}</NoteTitle>
          </InnerYellowFrame>
        </ShadowLayer>
      </Picture>
    </Link>
  );
};

export default NoteCardDetail;
